module.exports = __webpack_public_path__ + "static/media/downButton.84444538.svg";